import { WidgetFactory } from '@sitecore-search/widgets';
import { widget } from './experiences/index.js';
class ReactWidgetFactory extends WidgetFactory {
    doSetup({ type, entity, component, }) {
        return widget(component, type, entity);
    }
}
export default ReactWidgetFactory;
